<template>
    <div>
        <template v-if="subscription_fee === true">
            <div class="page-top mb-1 mb-3 clearfix">
                <router-link to="/addCompanyWiseSubscriptionFeeComponent" class="btn btn-primary active float-right"> Add</router-link>
              <div class="searching float-right mr-2">
                <input id="customSearch" type="text" class="form-control search" companyName="" />
              </div>
            </div>
            <table id="SubscriptionFeeTable" class="table" width="100%">
                <thead>
                    <tr>
                        <th>Company</th>
                        <th>Charges</th>
                        <th>Pre Balance</th>
                        <th>Post Balance</th>
                        <th>Last Deducted</th>
                        <th>Defaulting Month Count</th>
                        <th>Status</th>
                        <th class="text-center">Action</th>
                    </tr>
                </thead>
            </table>
        </template>
        <template v-else-if="subscription_fee === null">
            <preLoader></preLoader>
        </template>
        <template v-else-if="subscription_fee === false">
            <notAllowed></notAllowed>
        </template>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                data : null,
                pageView: null,
              subscription_fee: null
            };
        },
        methods: {
            callDataTable(){
                var that = this;
                var SubscriptionFeeTable = $('#SubscriptionFeeTable').DataTable({
                    "sDom": '<"table-holder mb-3"t><"row view-pager"<"col-sm-4 text-left"i"><"col-sm-4 text-center"p"><"col-sm-4 text-right"l>>r',
                    processing: true,
                    serverSide: true,
                    searching: true,
                    ajax: {
                        "url": "api/listSubscriptionFee",
                        "headers": window.axios.defaults.headers.common,
                        "dataSrc": "records",
                    },
                    deferRender: true,
                    columns: [
                        {data: 'companyName'},
                        {data: 'charges'},
                        {data: 'pre_balance'},
                        {data: 'post_balance'},
                        {data: 'last_deducted'},
                        {data: 'defaulting_month_count'},
                        {data: 'status'},
                        {data: 'id', sorting: false, render: function(data,type,full){
                            var $url = '/editCompanyWiseSubscriptionFeeComponent/'+full['company_id'];
                            return '<a href="javascript:void(0);" onclick="window.vueRouterPush(\''+$url+'\')" class="action edit" ><i class="fas fa-pencil-alt"></i></a>';
                        }}
                    ],
                    "order": [[ 0, "desc" ]],
                    "initComplete": () => {
                        this.$Progress.finish();
                    }
                });
              $('#customSearch').on( 'keyup', function (e) {
                if (e.keyCode === 13) {
                  SubscriptionFeeTable.search(this.value).draw();
                }
              });
            }
        },
        mounted() { 
            this.$Progress.start();
			this.can('subscription_fee').then(result => {
                this.subscription_fee = result.subscription_fee;
            }).then(result => {
                if(this.subscription_fee == true){
					this.callDataTable();
                    this.$Progress.finish();
                }else{
                    this.$Progress.finish();
                }
            });

        },
    }
</script>
